module.exports = __webpack_public_path__ + "static/media/tequan.0bfad888.png";